import { requestHandler } from '../../../utils/api';
import { LtiRequestType } from './types';

export type Lti1p3LaunchParams = {
  apiUrl: string;
  spaceId: string;
  clientId: string;
  type: LtiRequestType;
  userId: string;
  resourceLinkId: string;
  assignmentId: string;
};

type PayloadProps = {
  spaceId: string;
  clientId: string;
  type: string;
  resourceLinkId: string;
  assignmentId: string;
};

export const lti1p3Start = async ({
  apiUrl,
  spaceId,
  clientId,
  type,
  userId,
  resourceLinkId,
  assignmentId,
}: Lti1p3LaunchParams): Promise<string> => {
  const data: PayloadProps = {
    spaceId,
    clientId,
    type,
    resourceLinkId,
    assignmentId,
  };

  const result = await requestHandler({
    url: `${apiUrl}/lti/1p3/start`,
    method: 'post',
    userId,
    data,
  });

  const ltiSessionToken = result.data?.ltiSessionToken;

  if (!ltiSessionToken) {
    throw new Error('Expected API call to respond with ltiSessionToken');
  }

  return ltiSessionToken;
};
